import classNames from 'classnames';
import { memo } from 'react';

interface TableCellProps {
  item: React.ReactNode;
  className?: string;
  innerClassName?: string;
}

const _TableCell = ({ item, className, innerClassName }: TableCellProps) => {
  return (
    <td className={classNames('py-2.5 text-wthap_table_text', className)}>
      <p className={classNames('text-center', innerClassName)}>{item}</p>
    </td>
  );
};

export const TableCell = memo(_TableCell);
